var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBorrar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    rx: 8,
    fill: "#FBE6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4444 4C9.95353 4 9.55556 4.39175 9.55556 4.875C9.55556 5.35825 9.95353 5.75 10.4444 5.75H17.5556C18.0465 5.75 18.4444 5.35825 18.4444 4.875C18.4444 4.39175 18.0465 4 17.5556 4H10.4444ZM6 8.375C6 7.89175 6.39797 7.5 6.88889 7.5H9.55556H18.4444H21.1111C21.602 7.5 22 7.89175 22 8.375C22 8.85825 21.602 9.25 21.1111 9.25H20.2222V23.25C20.2222 24.2165 19.4263 25 18.4444 25H9.55556C8.57372 25 7.77778 24.2165 7.77778 23.25V9.25H6.88889C6.39797 9.25 6 8.85825 6 8.375ZM9.55556 9.25H18.4444V23.25H9.55556V9.25Z",
    fill: "#E36464"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorrar);
export default __webpack_public_path__ + "static/media/borrar.d90c825308257c199e2368040b576a32.svg";
export { ForwardRef as ReactComponent };